export const GenericErrorMessage = 'Something went wrong. Please try again later.';
